import { AutoFormFieldProps } from "@autoform/react";
import React, { useEffect } from "react";
import { PhoneInput } from "@components/ui/phone-input";
import { useAutoFormDefaultValues } from "../AutoForm";

export const PhoneField: React.FC<AutoFormFieldProps> = ({
  inputProps,
  error,
  id,
  control,
  path,
}) => {
  const defaultValues = useAutoFormDefaultValues();
  // @ts-ignore
  const [phone, setPhone] = React.useState(defaultValues[path.join(".")])
  const { key, name, ...props } = inputProps;

  useEffect(() => {
    control.unregister()
  }, [phone])

  return (
    <>
      <PhoneInput
        key={key}
        value={phone}
        className={error ? "border border-destructive" : ""}
        onChange={(e) => {
          setPhone(e)
        }}
      />
      <input type="hidden" id={id} value={phone} {...props} {...control.register(name)} />
    </>
  );
};
